import { useState } from "react";
import ClientsTable from "./clients-table";
import { ClientAppointmentsDialog } from "./client-appointments-dialog";
import type { Client } from "@/types/clients/api-types/client-types";

export const ClientsAppointmentsTabContent = () => {
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClientClick = (client: Client) => {
    setSelectedClient(client);
    setIsDialogOpen(true);
  };

  const handleDialogOpenChange = (open: boolean) => {
    setIsDialogOpen(open);
    if (!open) {
      setSelectedClient(null);
    }
  };

  return (
    <div className="mt-5">
      <ClientsTable
        showActions={false}
        onClientClick={handleClientClick}
      />
      {selectedClient && (
        <ClientAppointmentsDialog
          client={selectedClient}
          open={isDialogOpen}
          onOpenChange={handleDialogOpenChange}
        />
      )}
    </div>
  );
};
